import { useDevicePixelRatio } from './useDevicePixelRatio'
import { useDeviceOs } from './useDeviceOs'

export const useDprWithOs = () => {
  const pixelRatio = useDevicePixelRatio({ maxDpr: +Infinity, round: false })
  const os = useDeviceOs()
  return os === 'Windows' ? pixelRatio : 1
}
